export default "__VITE_ASSET__DA9M3RxV__"